<template>
  <el-popover popperClass="p-2" trigger="click" :width="260">
    <el-form :model="formData" label-position="top" @change.native="onChangeForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="Sonidos">
            <el-checkbox
              v-model="formData.muteSoundAll"
              size="mini"
              label="Anular todos los sonidos"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Sonidos de llamadas">
            <el-row>
              <el-col :span="24">
                <el-radio
                  v-model="formData.muteSoundCalls"
                  size="mini"
                  label="mute"
                  :disabled="formData.muteSoundAll"
                >
                  Sin sonido
                </el-radio>
              </el-col>
              <el-col :span="24">
                <el-radio
                  v-model="formData.muteSoundCalls"
                  size="mini"
                  label="onlyNotCalls"
                  :disabled="formData.muteSoundAll"
                >
                  Solo si no estoy hablando
                </el-radio>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Sonidos de llamadas en espera">
            <el-row>
              <el-col :span="24">
                <el-radio
                  v-model="formData.muteOnWaitingQueueSoundCalls"
                  size="mini"
                  :label="true"
                  :disabled="formData.muteSoundAll"
                >
                  Sin sonido
                </el-radio>
              </el-col>
              <el-col :span="24">
                <el-radio
                  v-model="formData.muteOnWaitingQueueSoundCalls"
                  size="mini"
                  :label="false"
                  :disabled="formData.muteSoundAll"
                >
                  Con sonido
                </el-radio>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Sonidos de notificaciones">
            <el-radio
              v-model="formData.muteSoundNotifications"
              size="mini"
              :label="false"
              :disabled="formData.muteSoundAll"
            >
              Sin sonido
            </el-radio>

            <el-radio
              v-model="formData.muteSoundNotifications"
              size="mini"
              :label="true"
              :disabled="formData.muteSoundAll"
            >
              Con sonido
            </el-radio>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-button slot="reference" class="pr-1 py-0 my-0" type="text">
      <i class="material-icons mr-1" style="font-size: 30px">
        {{ notificationsIcon }}
      </i>
      <label class="label-menu-item">Ring</label>
    </el-button>
  </el-popover>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "PopoverMuteSound",

  data() {
    return {
      formData: {
        muteSoundAll: false,
        muteSoundCalls: "onlyNotCalls",
        muteSoundNotifications: true,
      },
    };
  },

  computed: {
    ...mapGetters("clientMuteSoundPopover", ["muteSoundOptions"]),

    notificationsIcon() {
      if (this.formData.muteSoundAll) {
        return "notifications_off";
      } else if (
        !this.formData.muteSoundAll &&
        this.formData.muteSoundCalls === "onlyNotCalls" &&
        this.formData.muteSoundNotifications
      ) {
        return "notifications_active";
      } else {
        return "notifications_paused";
      }
    },
  },

  methods: {
    ...mapMutations("clientMuteSoundPopover", ["setMuteSoundOptions"]),

    onChangeForm() {
      this.setMuteSoundOptions(this.formData);
    },
  },

  mounted() {
    this.formData = JSON.parse(JSON.stringify(this.muteSoundOptions));
  },
};
</script>

<style scoped>
i {
  display: block;
}

.label-menu-item {
  font-size: 0.5rem;
}

::v-deep .el-form-item__content label {
  display: block;
  height: 32px;
}

::v-deep .el-form-item__label {
  margin-bottom: 5px;
}

.icon-bucle {
  display: inline-block;
  font-size: 16px;
  position: absolute;
  margin-left: 10px;
  color: grey;
}
</style>
